var cov_21s1vvcps6 = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Rule/index.ts",
      hash = "89e45b17a57737e6fce930cb22de98e04cb453d7",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Rule/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 10,
          column: 25
        },
        end: {
          line: 10,
          column: 38
        }
      },
      "1": {
        start: {
          line: 11,
          column: 34
        },
        end: {
          line: 11,
          column: 101
        }
      },
      "2": {
        start: {
          line: 13,
          column: 21
        },
        end: {
          line: 26,
          column: 1
        }
      },
      "3": {
        start: {
          line: 14,
          column: 2
        },
        end: {
          line: 17,
          column: 3
        }
      },
      "4": {
        start: {
          line: 15,
          column: 4
        },
        end: {
          line: 15,
          column: 74
        }
      },
      "5": {
        start: {
          line: 16,
          column: 4
        },
        end: {
          line: 16,
          column: 13
        }
      },
      "6": {
        start: {
          line: 19,
          column: 2
        },
        end: {
          line: 19,
          column: 36
        }
      },
      "7": {
        start: {
          line: 19,
          column: 25
        },
        end: {
          line: 19,
          column: 36
        }
      },
      "8": {
        start: {
          line: 20,
          column: 14
        },
        end: {
          line: 20,
          column: 27
        }
      },
      "9": {
        start: {
          line: 21,
          column: 2
        },
        end: {
          line: 23,
          column: 4
        }
      },
      "10": {
        start: {
          line: 22,
          column: 4
        },
        end: {
          line: 22,
          column: 76
        }
      },
      "11": {
        start: {
          line: 22,
          column: 38
        },
        end: {
          line: 22,
          column: 76
        }
      },
      "12": {
        start: {
          line: 24,
          column: 12
        },
        end: {
          line: 24,
          column: 32
        }
      },
      "13": {
        start: {
          line: 25,
          column: 2
        },
        end: {
          line: 25,
          column: 33
        }
      },
      "14": {
        start: {
          line: 51,
          column: 18
        },
        end: {
          line: 51,
          column: 43
        }
      },
      "15": {
        start: {
          line: 52,
          column: 28
        },
        end: {
          line: 58,
          column: 3
        }
      },
      "16": {
        start: {
          line: 57,
          column: 31
        },
        end: {
          line: 57,
          column: 52
        }
      },
      "17": {
        start: {
          line: 60,
          column: 2
        },
        end: {
          line: 60,
          column: 107
        }
      },
      "18": {
        start: {
          line: 60,
          column: 65
        },
        end: {
          line: 60,
          column: 107
        }
      },
      "19": {
        start: {
          line: 61,
          column: 2
        },
        end: {
          line: 61,
          column: 106
        }
      },
      "20": {
        start: {
          line: 61,
          column: 64
        },
        end: {
          line: 61,
          column: 106
        }
      },
      "21": {
        start: {
          line: 63,
          column: 2
        },
        end: {
          line: 65,
          column: 4
        }
      },
      "22": {
        start: {
          line: 64,
          column: 4
        },
        end: {
          line: 64,
          column: 50
        }
      },
      "23": {
        start: {
          line: 67,
          column: 19
        },
        end: {
          line: 67,
          column: 37
        }
      },
      "24": {
        start: {
          line: 68,
          column: 2
        },
        end: {
          line: 76,
          column: 4
        }
      },
      "25": {
        start: {
          line: 69,
          column: 4
        },
        end: {
          line: 75,
          column: 5
        }
      },
      "26": {
        start: {
          line: 70,
          column: 6
        },
        end: {
          line: 74,
          column: 7
        }
      },
      "27": {
        start: {
          line: 71,
          column: 8
        },
        end: {
          line: 71,
          column: 79
        }
      },
      "28": {
        start: {
          line: 71,
          column: 40
        },
        end: {
          line: 71,
          column: 79
        }
      },
      "29": {
        start: {
          line: 73,
          column: 8
        },
        end: {
          line: 73,
          column: 89
        }
      },
      "30": {
        start: {
          line: 78,
          column: 2
        },
        end: {
          line: 80,
          column: 4
        }
      },
      "31": {
        start: {
          line: 79,
          column: 4
        },
        end: {
          line: 79,
          column: 32
        }
      },
      "32": {
        start: {
          line: 82,
          column: 2
        },
        end: {
          line: 82,
          column: 26
        }
      },
      "33": {
        start: {
          line: 83,
          column: 2
        },
        end: {
          line: 83,
          column: 28
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 13,
            column: 21
          },
          end: {
            line: 13,
            column: 22
          }
        },
        loc: {
          start: {
            line: 13,
            column: 83
          },
          end: {
            line: 26,
            column: 1
          }
        },
        line: 13
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 21,
            column: 27
          },
          end: {
            line: 21,
            column: 28
          }
        },
        loc: {
          start: {
            line: 21,
            column: 32
          },
          end: {
            line: 23,
            column: 3
          }
        },
        line: 21
      },
      "2": {
        name: "Rule",
        decl: {
          start: {
            line: 50,
            column: 24
          },
          end: {
            line: 50,
            column: 28
          }
        },
        loc: {
          start: {
            line: 50,
            column: 52
          },
          end: {
            line: 84,
            column: 1
          }
        },
        line: 50
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 57,
            column: 10
          },
          end: {
            line: 57,
            column: 11
          }
        },
        loc: {
          start: {
            line: 57,
            column: 31
          },
          end: {
            line: 57,
            column: 52
          }
        },
        line: 57
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 60,
            column: 17
          },
          end: {
            line: 60,
            column: 18
          }
        },
        loc: {
          start: {
            line: 60,
            column: 65
          },
          end: {
            line: 60,
            column: 107
          }
        },
        line: 60
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 61,
            column: 16
          },
          end: {
            line: 61,
            column: 17
          }
        },
        loc: {
          start: {
            line: 61,
            column: 64
          },
          end: {
            line: 61,
            column: 106
          }
        },
        line: 61
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 63,
            column: 20
          },
          end: {
            line: 63,
            column: 21
          }
        },
        loc: {
          start: {
            line: 63,
            column: 25
          },
          end: {
            line: 65,
            column: 3
          }
        },
        line: 63
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 68,
            column: 31
          },
          end: {
            line: 68,
            column: 32
          }
        },
        loc: {
          start: {
            line: 68,
            column: 36
          },
          end: {
            line: 76,
            column: 3
          }
        },
        line: 68
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 71,
            column: 19
          },
          end: {
            line: 71,
            column: 20
          }
        },
        loc: {
          start: {
            line: 71,
            column: 40
          },
          end: {
            line: 71,
            column: 79
          }
        },
        line: 71
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 78,
            column: 30
          },
          end: {
            line: 78,
            column: 31
          }
        },
        loc: {
          start: {
            line: 78,
            column: 38
          },
          end: {
            line: 80,
            column: 3
          }
        },
        line: 78
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 13,
            column: 22
          },
          end: {
            line: 13,
            column: 43
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 13,
            column: 41
          },
          end: {
            line: 13,
            column: 43
          }
        }],
        line: 13
      },
      "1": {
        loc: {
          start: {
            line: 14,
            column: 2
          },
          end: {
            line: 17,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 14,
            column: 2
          },
          end: {
            line: 17,
            column: 3
          }
        }, {
          start: {
            line: 14,
            column: 2
          },
          end: {
            line: 17,
            column: 3
          }
        }],
        line: 14
      },
      "2": {
        loc: {
          start: {
            line: 19,
            column: 2
          },
          end: {
            line: 19,
            column: 36
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 19,
            column: 2
          },
          end: {
            line: 19,
            column: 36
          }
        }, {
          start: {
            line: 19,
            column: 2
          },
          end: {
            line: 19,
            column: 36
          }
        }],
        line: 19
      },
      "3": {
        loc: {
          start: {
            line: 22,
            column: 4
          },
          end: {
            line: 22,
            column: 76
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 22,
            column: 4
          },
          end: {
            line: 22,
            column: 76
          }
        }, {
          start: {
            line: 22,
            column: 4
          },
          end: {
            line: 22,
            column: 76
          }
        }],
        line: 22
      },
      "4": {
        loc: {
          start: {
            line: 64,
            column: 23
          },
          end: {
            line: 64,
            column: 49
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 64,
            column: 23
          },
          end: {
            line: 64,
            column: 33
          }
        }, {
          start: {
            line: 64,
            column: 37
          },
          end: {
            line: 64,
            column: 49
          }
        }],
        line: 64
      },
      "5": {
        loc: {
          start: {
            line: 69,
            column: 4
          },
          end: {
            line: 75,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 69,
            column: 4
          },
          end: {
            line: 75,
            column: 5
          }
        }, {
          start: {
            line: 69,
            column: 4
          },
          end: {
            line: 75,
            column: 5
          }
        }],
        line: 69
      },
      "6": {
        loc: {
          start: {
            line: 70,
            column: 6
          },
          end: {
            line: 74,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 70,
            column: 6
          },
          end: {
            line: 74,
            column: 7
          }
        }, {
          start: {
            line: 70,
            column: 6
          },
          end: {
            line: 74,
            column: 7
          }
        }],
        line: 70
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0
    },
    b: {
      "0": [0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import { deepMerge, objectValues } from '../utils/objects';
import { isObject } from '../utils/is';
import required from './required';
import length from './length';
import _type from './type';
import regExp from './regExp';
export var RULE_TYPE = (cov_21s1vvcps6.s[0]++, 'RULE_OBJECT');
var innerType = (cov_21s1vvcps6.s[1]++, ['email', 'integer', 'number', 'url', 'json', 'hex', 'rgb', 'ipv4']);
cov_21s1vvcps6.s[2]++;

var mergeOptions = function mergeOptions() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (cov_21s1vvcps6.b[0][0]++, {});
  cov_21s1vvcps6.f[0]++;
  cov_21s1vvcps6.s[3]++;

  if (!isObject(opts)) {
    cov_21s1vvcps6.b[1][0]++;
    cov_21s1vvcps6.s[4]++;
    console.error(new Error("rules expect an object, got ".concat(typeof opts)));
    cov_21s1vvcps6.s[5]++;
    return {};
  } else {
    cov_21s1vvcps6.b[1][1]++;
  }

  cov_21s1vvcps6.s[6]++;

  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  if (args.length === 0) {
    cov_21s1vvcps6.b[2][0]++;
    cov_21s1vvcps6.s[7]++;
    return opts;
  } else {
    cov_21s1vvcps6.b[2][1]++;
  }

  var arg = (cov_21s1vvcps6.s[8]++, args.shift());
  cov_21s1vvcps6.s[9]++;
  Object.keys(arg).forEach(function (k) {
    cov_21s1vvcps6.f[1]++;
    cov_21s1vvcps6.s[10]++;

    if (typeof arg[k] === 'function') {
      cov_21s1vvcps6.b[3][0]++;
      cov_21s1vvcps6.s[11]++;
      arg[k] = {
        func: arg[k]
      };
    } else {
      cov_21s1vvcps6.b[3][1]++;
    }
  });
  var a = (cov_21s1vvcps6.s[12]++, deepMerge(opts, arg));
  cov_21s1vvcps6.s[13]++;
  return mergeOptions.apply(void 0, [a].concat(args));
};

export default function Rule() {
  cov_21s1vvcps6.f[2]++;

  for (var _len2 = arguments.length, opts = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    opts[_key2] = arguments[_key2];
  }

  var options = (cov_21s1vvcps6.s[14]++, mergeOptions.apply(void 0, [{}].concat(opts)));
  var rules = (cov_21s1vvcps6.s[15]++, {
    required: required(options.required),
    max: length('max', options.max),
    min: length('min', options.min),
    regExp: regExp(options.regExp),
    type: function type(t) {
      cov_21s1vvcps6.f[3]++;
      cov_21s1vvcps6.s[16]++;
      return _type(t, options.type);
    }
  });
  cov_21s1vvcps6.s[17]++;

  rules.length = function (min, max, msg) {
    cov_21s1vvcps6.f[4]++;
    cov_21s1vvcps6.s[18]++;
    return [rules.min(min, msg), rules.max(max, msg)];
  };

  cov_21s1vvcps6.s[19]++;

  rules.range = function (min, max, msg) {
    cov_21s1vvcps6.f[5]++;
    cov_21s1vvcps6.s[20]++;
    return [rules.min(min, msg), rules.max(max, msg)];
  };

  cov_21s1vvcps6.s[21]++;
  innerType.forEach(function (k) {
    cov_21s1vvcps6.f[6]++;
    cov_21s1vvcps6.s[22]++;
    rules[k] = _type(k, (cov_21s1vvcps6.b[4][0]++, options[k]) || (cov_21s1vvcps6.b[4][1]++, options.type));
  });
  var ruleKeys = (cov_21s1vvcps6.s[23]++, Object.keys(rules));
  cov_21s1vvcps6.s[24]++;
  Object.keys(options).forEach(function (k) {
    cov_21s1vvcps6.f[7]++;
    cov_21s1vvcps6.s[25]++;

    if (!ruleKeys.includes(k)) {
      cov_21s1vvcps6.b[5][0]++;
      cov_21s1vvcps6.s[26]++;

      if (isObject(options[k])) {
        cov_21s1vvcps6.b[6][0]++;
        cov_21s1vvcps6.s[27]++;

        rules[k] = function (args) {
          cov_21s1vvcps6.f[8]++;
          cov_21s1vvcps6.s[28]++;
          return Object.assign({}, options[k], {
            args: args
          });
        };
      } else {
        cov_21s1vvcps6.b[6][1]++;
        cov_21s1vvcps6.s[29]++;
        console.error(new Error("Rule ".concat(k, " is invalid, expect a function or an object.")));
      }
    } else {
      cov_21s1vvcps6.b[5][1]++;
    }
  });
  cov_21s1vvcps6.s[30]++;
  objectValues(rules).forEach(function (rule) {
    cov_21s1vvcps6.f[9]++;
    cov_21s1vvcps6.s[31]++;
    rule.isInnerValidator = true;
  });
  cov_21s1vvcps6.s[32]++;
  rules.$$type = RULE_TYPE;
  cov_21s1vvcps6.s[33]++;
  return rules;
}